import { API } from 'aws-amplify';
import { STUDENT_PROFILE_FILTER_OPTION_BASE_URL_APPEND } from 'constants';

export const getStudentProfileDetail = async (studentId) => {
  const studentProfile = await API.get(
    'delta-api',
    `${STUDENT_PROFILE_FILTER_OPTION_BASE_URL_APPEND}${studentId}`
  );
  return studentProfile;
};

export const getSsaDashboardPassword = async (studentId) => {
  const dashboardPassword = await API.get(
    'delta-api',
    `${STUDENT_PROFILE_FILTER_OPTION_BASE_URL_APPEND}${studentId}/dashboardPassword`
  );
  return dashboardPassword;
};

export const resetSsaDashboardPassword = async (studentId) => {
  await API.post(
    'delta-api',
    `${STUDENT_PROFILE_FILTER_OPTION_BASE_URL_APPEND}${studentId}/resetDashboardPassword`
  );
};
